// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, isSupported } from 'firebase/messaging'

// const firebaseConfig = {
//   apiKey: 'AIzaSyD3OOjyyTC4rG3QfwfRR8R_A4MdAfuaLYQ',
//   authDomain: 'synapp-expertise.firebaseapp.com',
//   projectId: 'synapp-expertise',
//   storageBucket: 'synapp-expertise.appspot.com',
//   messagingSenderId: '289871049880',
//   appId: '1:289871049880:web:c396b1b016080707eb0ced',
//   measurementId: 'G-KKEQVC6XCM'
// }

const firebaseConfig = {
  apiKey: 'AIzaSyAQ0zD5rZg6GMUh_RQDJx9PPKxXDU-obIw',
  authDomain: 'medi-sync-3e00d.firebaseapp.com',
  projectId: 'medi-sync-3e00d',
  storageBucket: 'medi-sync-3e00d.firebasestorage.app',
  messagingSenderId: '472352249456',
  appId: '1:472352249456:web:1b1fd158331c3ddfc086b5'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

async function getSupportFn(cb) {
  return await cb()
}

export const messaging = getSupportFn(isSupported) ? getMessaging(app) : null

// Register service worker for Firebase messaging
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      // Check if service worker is already registered
      let registration = await navigator.serviceWorker.getRegistration()
      
      if (!registration) {
        // Register if not already registered
        registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
          scope: '/'
        })
        console.log('Service Worker registered successfully:', registration)
      } else {
        console.log('Service Worker already registered:', registration)
      }
      
      // Wait for service worker to be ready
      await navigator.serviceWorker.ready
      
      return registration
    } catch (error) {
      console.error('Service Worker registration failed:', error)
      throw error
    }
  }
  return null
}

export const generateToken = async () => {
  if (getSupportFn(isSupported)) {
    try {
      // Register service worker first (this also waits for it to be ready)
      const registration = await registerServiceWorker()
      
      if (!registration) {
        console.error('Service Worker registration failed')
        return null
      }

      const permission = await Notification.requestPermission()
      if (permission === 'granted') {
        const token = await getToken(messaging, {
          vapidKey:
            // 'BMK1ttKB-t2q-TgTd-hEEc9Ze1tz3ECJVQOHemH5nbGa_vyvnGW9Xep7eJBbeywXpGTE6SB62Gr9bNwUwc8I1U8'
            'BB5WtljXnYVfjlDZ4zuWF9hihcTx0CjoYerlf-wP_c7YHXmFXxNYoDyVFw34VGJ-CjJWshbJfgOrFVJxXb_FVgc',
          serviceWorkerRegistration: registration
        })
        console.log('token --->>>', token)
        return token
      } else {
        // handleOpenGenerateTokenDialog('NotificationsAreNotGranted')
        return null
      }
    } catch (error) {
      console.error('Error generating Firebase token:', error)
      // handleOpenGenerateTokenDialog('NotificationsAreNotSupported')
      return null
    }
  } else {
    // handleOpenGenerateTokenDialog('NotificationsAreNotSupported')
    return null
  }
}
